import { render, staticRenderFns } from "./lock.vue?vue&type=template&id=35a1e4eb&scoped=true&"
import script from "./lock.vue?vue&type=script&lang=ts&"
export * from "./lock.vue?vue&type=script&lang=ts&"
import style0 from "./lock.vue?vue&type=style&index=0&id=35a1e4eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a1e4eb",
  null
  
)

export default component.exports